import { useMediaQuery } from '@aimsos/hooks';
import { FILTERS_BAR_BREAKPOINTS } from './filtersResponsive.js';

/** `true` cuando el toolbar usa layout desktop completo (`xl+`, ≥1280px). */
export function useFiltersIsDesktopToolbar() {
  return useMediaQuery(`(min-width: ${FILTERS_BAR_BREAKPOINTS.desktop}px)`);
}
